import React from 'react';
import { Image } from '@chakra-ui/react';
import footerLogo from '@/assets/templebet/images/logo/logo-mobile4x.png';

export default function index() {
  return <Image src={footerLogo} w="168px" h="46px" mb="0" />;
}
